// Body padding mirrors the modal header's horizontal padding (32px) and adds
// generous bottom padding so the last row + badge never sit flush against the
// rounded corner. The modal shell (shared/ui/modal) owns width/scroll.
.body {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 0 2rem 2rem;
}

.grid {
  align-items: baseline;
  color: var(--color-muted);
  column-gap: 1rem;
  display: grid;
  // First column sized to the labels; the two value columns share the rest
  // equally and are allowed to shrink (minmax(0, …)) so long values wrap
  // instead of forcing horizontal overflow.
  grid-template-columns: auto minmax(0, 1fr) minmax(0, 1fr);
  row-gap: 1rem;
}

.label {
  color: var(--color-foreground);
  font-weight: 600;
  white-space: nowrap;
}

.col-head {
  color: var(--color-foreground);
  text-decoration: underline;
}

.value {
  min-width: 0;
  overflow-wrap: anywhere;
}

.badge {
  border-radius: 0.5rem;
  padding: 0.625rem 0.75rem;
}

.badge-ok {
  background: var(--color-success);
  color: var(--color-success-foreground);
}

.badge-drift {
  background: var(--color-warning);
  color: var(--color-warning-foreground);
}
